import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Layout.css';

interface Props {
  children: React.ReactNode;
  onLogout: () => void;
}

const NAV = [
  { to: '/', label: 'Dashboard', icon: '◈' },
  { to: '/herca', label: 'Herca Records', icon: '⊞' },
  { to: '/employees', label: 'Employees', icon: '👤' },
  { to: '/areas', label: 'Areas', icon: '📍' },
  { to: '/deviations', label: 'Deviation Types', icon: '⚑' },
  { to: '/reports', label: 'Reports', icon: '📊' },
];

const Layout = ({ children, onLogout }: Props) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={`layout ${collapsed ? 'layout--collapsed' : ''}`}>
      <aside className="sidebar">
        <div className="sidebar-header">
          <div className="sidebar-logo">GM</div>
          {!collapsed && (
            <div className="sidebar-brand">
              <span className="sidebar-brand-title">Grifols</span>
              <span className="sidebar-brand-sub">Deviation Manager</span>
            </div>
          )}
        </div>

        <nav className="sidebar-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `nav-item${isActive ? ' nav-item--active' : ''}`
              }
            >
              <span className="nav-icon">{item.icon}</span>
              {!collapsed && <span className="nav-label">{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        <button className="sidebar-collapse-btn" onClick={() => setCollapsed(!collapsed)}>
          {collapsed ? '»' : '«'}
        </button>
      </aside>

      <div className="main-area">
        <header className="topbar">
          <span className="topbar-title">Grifols Deviation Manager</span>
          <button className="topbar-logout" onClick={onLogout}>
            Sign Out
          </button>
        </header>
        <main className="page-content">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
